// extracted by mini-css-extract-plugin
export default {"container":"_1TEw","chatReviewer":"_2E9Q","comment":"_1fFE","moderationControls":"_3MuY"};